import(/* webpackMode: "eager" */ "/vercel/path0/src/app/darmowy-projekt/page.tsx");
